import { useSyncExternalStore } from 'react';
import {
  getDictionary,
  getLocale,
  setLocale,
  subscribeLocale,
  type Dictionary,
  type LocaleCode,
} from '@/i18n';

/**
 * Access the active locale's dictionary in React. Returns a `t` object
 * that matches the `Dictionary` type exactly — no string-indexing, full
 * TS autocomplete (e.g. `t.projects.newProject`).
 *
 * Using useSyncExternalStore guarantees we re-render when the user flips
 * the language from the TopBar menu, even from a deep child.
 */
export function useT(): {
  t: Dictionary;
  locale: LocaleCode;
  setLocale: (next: LocaleCode) => void;
} {
  const locale = useSyncExternalStore(subscribeLocale, getLocale, getLocale);
  const t = getDictionary(locale);
  return { t, locale, setLocale };
}
